
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { getToken } from '@/utils/cookies'
import { deleteImage } from '@/api/common'
@Component({
  name: 'UploadImage'
})
export default class extends Vue {
  @Prop({ default: '.jpg,.jpeg,.png' }) type: string
  @Prop({ default: 20 }) size: number
  @Prop({ default: '' }) propImageUrl: string
  /** MinIO 子目录：dish / setmeal / avatar / notice / banner / category / store / common */
  @Prop({ default: 'common' }) folder: string
  /** 为 false 时不展示「删除图片」（如套餐封面回退商品图） */
  @Prop({ default: true }) allowDelete: boolean
  /** 受保护 URL：不从存储删除（如商品图被套餐预览引用） */
  @Prop({ default: '' }) protectedUrl: string
  /** 1:1 正方形预览（商品主图/详情图） */
  @Prop({ default: false }) square: boolean
  /** 预览裁切：cover 裁切铺满；contain 完整显示（对齐小程序详情弹窗） */
  @Prop({ default: 'cover' }) objectFit: string

  private headers = {
    token: getToken()
  }
  private imageUrl = ''
  /** 本次重新上传开始前的旧图，成功后再删，避免上传失败丢图 */
  private pendingReplaceUrl = ''

  get uploadAction() {
    const base = (process.env.VUE_APP_BASE_API || '/api') + '/common/upload'
    const folder = (this.folder || 'common').trim()
    return `${base}?folder=${encodeURIComponent(folder)}`
  }

  get showDeleteBtn() {
    return !!this.allowDelete && !this.isProtectedUrl(this.imageUrl)
  }

  handleRemove() {}

  mounted() {
    this.imageUrl = this.propImageUrl || ''
  }

  @Watch('propImageUrl', { immediate: true })
  private onChange(val) {
    this.imageUrl = val || ''
  }

  private isProtectedUrl(url: string) {
    const protect = (this.protectedUrl || '').trim()
    const current = (url || '').trim()
    return !!protect && !!current && protect === current
  }

  private normalizeRemoteUrl(url: string) {
    const s = (url || '').trim()
    if (!s) return ''
    if (s.indexOf('//') === 0) return 'https:' + s
    return s
  }

  private async removeRemoteIfAllowed(url: string) {
    const target = this.normalizeRemoteUrl(url)
    if (!target || this.isProtectedUrl(target) || this.isProtectedUrl(url)) return
    if (!(target.startsWith('http://') || target.startsWith('https://'))) return
    try {
      await deleteImage(target)
    } catch (e) {
      console.warn('删除图片失败:', e)
    }
  }

  handleError(err, file, fileList) {
    console.log(err, file, fileList, 'handleError')
    this.pendingReplaceUrl = ''
    this.$message({
      message: '图片上传失败',
      type: 'error'
    })
  }

  async handleAvatarSuccess(response: any) {
    let raw = response
    if (typeof raw === 'string') {
      try {
        raw = JSON.parse(raw)
      } catch (e) {
        raw = response
      }
    }
    const body = raw && raw.data !== undefined ? raw : { data: raw }
    if (String(body.code) !== '1' && body.code !== 1) {
      this.pendingReplaceUrl = ''
      this.$message.error(body.msg || '图片上传失败')
      return
    }
    const url = body.data
    if (!url) {
      this.pendingReplaceUrl = ''
      this.$message.error('上传成功但未返回图片地址')
      return
    }
    const oldUrl = this.pendingReplaceUrl || this.imageUrl
    const newUrl = String(url)
    this.pendingReplaceUrl = ''
    // 重新上传成功后再删旧图（分类/商品/轮播共用）；受保护 URL 不删
    if (oldUrl && oldUrl !== newUrl) {
      await this.removeRemoteIfAllowed(oldUrl)
    }
    this.imageUrl = newUrl
    this.$emit('imageChange', this.imageUrl)
  }

  async oploadImgDel() {
    if (!this.showDeleteBtn) return
    const url = this.imageUrl
    await this.removeRemoteIfAllowed(url)
    this.imageUrl = ''
    this.$emit('imageChange', this.imageUrl)
  }
  beforeAvatarUpload(file) {
    const isLt2M = file.size / 1024 / 1024 < this.size
    if (!isLt2M) {
      this.pendingReplaceUrl = ''
      this.$message({
        message: `上传文件大小不能超过${this.size}M!`,
        type: 'error'
      })
      return false
    }
    this.pendingReplaceUrl = this.imageUrl || this.propImageUrl || ''
    return true
  }
}
